export const ACTION_SHOW = 'ACTION_SHOW'
export const ACTION_SUBMIT = 'ACTION_SUBMIT'
export const ACTION_HIDE = 'ACTION_HIDE'
export const ACTION_MOVE_LEFT = 'ACTION_MOVE_LEFT'
export const ACTION_MOVE_RIGHT = 'ACTION_MOVE_RIGHT'
export const ACTION_SELECT = 'ACTION_SELECT'
export const ACTION_DELETE = 'ACTION_DELETE'
export const ACTION_TOGGLE_CASE = 'ACTION_TOGGLE_CASE'
